import { render, staticRenderFns } from "./IpAddresses.vue?vue&type=template&id=726bf972&lang=pug&"
import script from "./IpAddresses.vue?vue&type=script&lang=js&"
export * from "./IpAddresses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports